export default "__VITE_ASSET__BVhU8XbD__"